import { DefaultLayout } from '../lib/layouts/layouts';
import { RouteMeta } from 'vue-router';

export const defaultMeta: RouteMeta = {
  layoutComponent: DefaultLayout,
  backButton: true,
  formConfig: null,
  layoutPageTitle: null,
};
